import { ServiceStatus, } from '@chr/online-shared-ui-constants';

export enum RiskLevelType {
  Unassigned = 'Unassigned',
  Early = 'Early',
  Late = 'Late',
  OnTime = 'On Time',
  AtRisk = 'At Risk',
}

export enum StopStatus {
  None = '',
  Completed = 'Completed',
  Current = 'Current',
  InTransit = 'In Transit',
  Upcoming = 'Upcoming',
}

export enum DisplayEtaSource {
  None = '',
  ChrGlobalForwarding = 'CHR Global Forwarding',
  DataScience = 'Data Science',
  Carrier = 'Carrier',
}

export const BookingStatusLabels = {
  [ServiceStatus.INCOMPLETE]: 'Incomplete',
  [ServiceStatus.BOOKED]: 'Booked',
  [ServiceStatus.ORDERED]: 'Ordered',
  [ServiceStatus.IN_TRANSIT]: 'In Transit',
  [ServiceStatus.DELIVERED]: 'Delivered',
  [ServiceStatus.CANCELLED]: 'Cancelled',
};

export enum TransportMode {
  NONE = 'NONE', // Convenience enum value for when we don't have a transport mode
  AIR = 'AIR',
  OCEAN = 'OCEAN',
}

export enum StopType {
  'None' = -1,
  'Pickup From' = 0,
  'Deliver To' = 1,
  'Cross Dock' = 2,
  'Destination Airport' = 3,
  'Destination Port' = 4,
  'Destination Ramp' = 5,
  'Destination Terminal' = 6,
  'Intermediary Airport' = 7,
  'Intermediary Port' = 8,
  'Intermediary Ramp' = 9,
  'Origin Airport' = 10,
  'Origin Port' = 11,
  'Origin Ramp' = 12,
  'Origin Terminal' = 13,
}

export enum StopStyle {
  Airport = 'A',
  Normal = 'N',
  Port = 'P',
  Ramp = 'R',
  Terminal = 'T',
  CrossBorder = 'X',
}

export enum CustomerFreightTerms {
  Prepaid = "Prepaid",
  Collect = "Collect",
}

export enum IncoTerms {
  EXW = "EXW",
  FCA = "FCA",
  FAS = "FAS",
  FOB = "FOB",
  CFR = "CFR",
  CIF = "CIF",
  CPT = "CPT",
  CIP = "CIP",
  DAF = "DAF",
  DES = "DES",
  DEQ = "DEQ",
  DDU = "DDU",
  DDP = "DDP",
  DAP = "DAP",
  DAT = "DAT",
  DPU = "DPU",
}

export enum PartyRole {
  CustomsAgent = "CustomsAgent",
  Shipper = "Shipper",
  Consignee = "Consignee",
  OriginForwardingParty = "OriginForwardingParty",
  DestinationForwardingParty = "DestinationForwardingParty",
  Manufacturer = "Manufacturer",
}

export enum ShipmentRole {
  FF = "FF",
  NVOCC = "NVOCC",
  Direct = "Direct",
  House = "House",
  None = "None",
}

export enum StopRoleRdn {
  Pickup = "Pickup",
  Delivery = "Delivery",
}

export type StopActivityDateKey =
  'arrivedDateTime' |
  'requestedDateTime' |
  'departureDateTime' |
  'eta' |
  'etd' |
  'calculatedEta' |
  'displayEta' |
  'openDateTime' |
  'closeDateTime';
